import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TruthSection } from './components/TruthSection';
import { MethodsFailSection } from './components/MethodsFailSection';
import { MechanismSection } from './components/MechanismSection';
import { StatsSection } from './components/StatsSection';
import { ProductReveal } from './components/ProductReveal';
import { ModulesSection } from './components/ModulesSection';
import { RecipesSection } from './components/RecipesSection';
import { PaolaSection } from './components/PaolaSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { IsForYouSection } from './components/IsForYouSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <main className="min-h-screen w-full bg-cream font-body text-text-main overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <TruthSection data-id="element-3" />
      <MethodsFailSection data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <StatsSection data-id="element-6" />
      <ProductReveal data-id="element-7" />
      <ModulesSection data-id="element-8" />
      <RecipesSection data-id="element-9" />
      <PaolaSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <IsForYouSection data-id="element-12" />
      <OfferSection data-id="element-13" />
      <GuaranteeSection data-id="element-14" />
      <FAQSection data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
      <RecentPurchaseToast data-id="element-18" />
    </main>;
}